import { Category } from "./category";
import { ChartOfAccount } from "./chart-of-account";
import { Photo } from "./photo";
import { PricebookEntry } from "./pricebook-entry";
import { ProductProperty } from "./product-property";
import { ProductWarehouseDetail } from "./product-warehouse-detail";
import { SystemField } from "./system-field";

export class Product extends SystemField{
     
    photo?:string;
    is_active?:number;
    type?:string;
    has_stock?:number;
    best_sell?:number;
    is_comming?:number;
    video_link?:string;
    has_video?:number;
    is_recommend?:number;
    code?:string;
    sku?:string;
    record_type_id?:string;
    item_type?:string;
    status?:string;
    min_stock?:number;
    max_stock?:number;
    tags?:string;
    default_category_id?:string;
    is_kit?:number;
    base_uom?:string;
    cost_method?:string;
    cost?:number;
    option_master_id?:string;
    frequency_ids?:string;
    addon_ids?:string;
    category_ids?:string;
    is_new?:number;
    slug?:string;
    tag_ids?:string;
    for_pos_sale?:number;
    brand?:string;
    ind_brand?:string;
    model?:string;
    year?:string;
    store_ids?:string;
    record_type_name?:string;
    photo_files?: File[];
    inventory_coa_id?:string;
    sale_coa_id?:string;
    cogs_coa_id?:string;
    std_cost_var_coa_id?:string;
    std_cost_rev_coa_id?:string;
    po_accrual_coa_id?:string;
    deferral_coa_id?:string;
    

     // Formula Fields
	photo_file?: File;
	photo_preview?: string;
    standard_unitprice?: number;
	standard_cost?: number;
	standard_regularprice?: number;
    frequencies?:Product[];
    created_by?:any;
    updated_by?:any;
    

    photos?:Photo[];
    pricebook_entries?:PricebookEntry[];
    // product_cost_statistics?:ProductCo
    properties?:ProductProperty[];
    warehouse_details?:ProductWarehouseDetail[];
    deferral_chart_of_account?:ChartOfAccount;
    po_accrual_chart_of_account?:ChartOfAccount;
    std_cost_rev_chart_of_account?:ChartOfAccount;
    std_cost_val_chart_of_account?:ChartOfAccount;
    chart_of_account?:ChartOfAccount;
    sale_chart_of_account?:ChartOfAccount;
    inventory_chart_of_account?:ChartOfAccount;
    category?: Category;
    langs?: any;
}
export class ProductTranslation extends SystemField{
      
      lang_code?:string;
      products_id?:string;
      name?:string;
      short_desc?:string;
      note?:string;
      sale_desc?:string;
      description?:string;
      notes?:string;
      other_note?:string;
      short_spec?:string;
}

export class PublicProduct extends Product{}